import {ApiV0Administration} from '../api.v0.administration';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {Observable} from 'rxjs';
import {RoleRes} from '../../../../contracts/v0/cp/role.contract';

export class ApiV0AdminRoles {
    segment = '/roles';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    search(dto?: SearchModel): Observable<BaseCollectionModel<RoleRes>> {
        dto = dto ?? new SearchModel({});
        return this.rest.post<SearchModel, BaseCollectionModel<RoleRes>>(`${this.segment}/search`, RoleRes, dto);
    }
}